import { z } from 'zod';
import { DisclaimerType } from '../../enums';

export const imageDisclaimer = z.object({
  type: z.literal(DisclaimerType.IMAGE),
  url: z.string(),
});

export type ImageDisclaimer = z.infer<typeof imageDisclaimer>;
